// frontend/src/components/Header.js
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Home, Grid3X3, Users, Settings, Info, Image, ShoppingBag,  Mail, Factory } from 'lucide-react';
import IndustrialLogo from './IndustrialLogo';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'خانه', href: '/', icon: Home },
    { name: 'محصولات', href: '/products', icon: ShoppingBag },
    { name: 'خدمات', href: '/services', icon: Settings },
    { name: 'درباره ما', href: '/about', icon: Users },
    { name: 'گالری', href: '/gallery', icon: Image },
    { name: 'بلاگ', href: '/blog', icon: Info },
    { name: 'تیم', href: '/portfolio', icon: Users },
    { name: 'تماس', href: '/contact', icon: Mail },
  ];

  return (
    <header className="bg-gray-900 border-b border-gray-800 sticky top-0 z-50">
      {/* Top Bar - اطلاعات شرکت */}
      <div className="bg-yellow-400 text-gray-900 py-2">
        <div className="container mx-auto px-4 flex justify-between items-center">
          <div className="text-sm font-medium">
            🏭 گروه صنعتی تکنو پلیمر اسپادانا
          </div>
          <div className="flex items-center space-x-4 space-x-reverse text-sm">
            <span>📞 03191550821</span>
            <span>🕒 08:00 - 18:00 </span>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="container mx-auto px-4 py-3">
        <div className="flex justify-between items-center">

          {/* Logo   */}
          <Link to="/" className="flex items-center space-x-3 space-x-reverse group">
            <IndustrialLogo variant="default" />
          </Link>

          {/* Desktop Navigation - منوی اصلی */}
          <div className="hidden lg:flex items-center space-x-8 space-x-reverse">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`font-medium transition-all duration-300 relative ${
                  location.pathname === item.href
                    ? 'text-yellow-400'
                    : 'text-gray-300 hover:text-yellow-400'
                }`}
              >
                {item.name}
                {location.pathname === item.href && (
                  <div className="absolute -bottom-2 left-0 right-0 h-0.5 bg-yellow-400 rounded-full"></div>
                )}
              </Link>
            ))}
          </div>

          {/* Desktop Navigation - آیکون‌ها */}
          <div className="hidden md:flex items-center space-x-4 space-x-reverse bg-gray-800 rounded-2xl p-2">
            {navigation.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.href;
              
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`p-3 rounded-xl transition-all duration-300 ${
                    isActive 
                      ? 'bg-yellow-400 text-gray-900 shadow-lg' 
                      : 'text-gray-400 hover:text-yellow-400 hover:bg-gray-700'
                  }`}
                  title={item.name}
                >
                  <Icon size={20} />
                </Link>
              );
            })}
          </div>

          {/* Mobile menu button */}
          <button
            className="lg:hidden p-2 text-gray-300 hover:text-yellow-400 transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden border-t border-gray-800 mt-4 py-4">
            <div className="flex flex-col space-y-2">
              {navigation.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.href;
                
                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`flex items-center space-x-3 space-x-reverse px-4 py-3 rounded-xl transition-all duration-300 ${
                      isActive
                        ? 'bg-yellow-400 text-gray-900'
                        : 'text-gray-300 hover:text-yellow-400 hover:bg-gray-800'
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <Icon size={20} />
                    <span className="font-medium">{item.name}</span>
                  </Link>
                );
              })}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;